export default "__VITE_ASSET__BbYCOFZ3__"